import graphql from "babel-plugin-relay/macro";

const UpcommingStocksQuery = graphql`
query UpcommingStocksQuery{
  allPoliticians(upcoming:true){
    edges{
      node{
        id
        name
         politicianImage
        party{
          partyName
        }
        price
        upcoming
        upcomingStocks
        upcomingStocksUsed 
        upcomingStocksPercentage   
        upcomingStocksSubscribed 
      }       
    }
  }
}
`

export default UpcommingStocksQuery;